import type { Milestone } from '../milestones/milestones.model';
import type { GenerateMilestoneOptions } from '../milestones/milestones.seed';
import { generateMilestoneObject } from '../milestones/milestones.seed';

export function generateSuperuserMilestoneObject(
  options: GenerateMilestoneOptions,
): Milestone {
  return generateMilestoneObject(options);
}
